// import { useCallback, useEffect } from 'react';
import { Layout } from 'react-admin';
import AppBar from './AppBar';
import Menu from './Menu';
// import { useClientContext } from 'contexts/client';
// import useInterval from 'useInterval';
 

const CustomLayout = (props: any) => {
    // const dataProvider = useDataProvider()
    
    // const { state: clientState } = useClientContext()
    
    return (
        <Layout 
            {...props}
            sx={{ '& .RaLayout-appFrame': { paddingTop: 1 } }}
            appBar={AppBar} 
            menu={Menu} 
            />
    )
};

export default CustomLayout;

